import { ImageFit, MagicConfigMixin, ImageFormat, cdnService, getImagePath, ImageType } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const cssBreakpoints = [
  1920,
  1050,
  896,
  672,
  525,
  524
];
const heights = [
  1.1,
  1.3,
  1.5,
  2,
  2.5,
  3
];
const validImageFit = Object.values(ImageFit);
let BackgroundComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.originalHeight = -1;
    this.originalWidth = -1;
  }
  created() {
    (() => __async(this, null, function* () {
      const result = yield fetch(this.getPath({
        format: ImageFormat.JSON
      }));
      const json = yield result.json();
      this.originalHeight = json.PixelHeight;
      this.originalWidth = json.PixelWidth;
    }))();
  }
  get customHeights() {
    var _a, _b;
    if (this.heights) {
      return this.heights.split(",").map((height) => parseFloat(height));
    }
    if ((_a = this.magicConfig.uiBackgroundConfig) == null ? void 0 : _a.aspectRatio) {
      return (_b = this.magicConfig.uiBackgroundConfig) == null ? void 0 : _b.aspectRatio;
    }
    return heights;
  }
  get customBreakpoints() {
    var _a, _b;
    if (this.breakpoints) {
      return this.breakpoints.split(",").map((breakpoint) => parseInt(breakpoint, 10));
    }
    if ((_a = this.magicConfig.uiBackgroundConfig) == null ? void 0 : _a.cssBreakpoints) {
      return (_b = this.magicConfig.uiBackgroundConfig) == null ? void 0 : _b.cssBreakpoints;
    }
    return cssBreakpoints;
  }
  get customImgFit() {
    var _a, _b;
    if (this.imgFit) {
      return this.imgFit;
    }
    if ((_a = this.magicConfig.uiBackgroundConfig) == null ? void 0 : _a.imgxFit) {
      return (_b = this.magicConfig.uiBackgroundConfig) == null ? void 0 : _b.imgxFit;
    }
    return ImageFit.CROP;
  }
  get cdnPath() {
    return this.getPath();
  }
  get alternatives() {
    const heights2 = this.customHeights;
    const breakpoints = this.customBreakpoints;
    if (this.originalHeight === -1) {
      return [];
    }
    const originalRatio = this.originalHeight / this.originalWidth;
    const alternatives = [];
    breakpoints.forEach((width, i) => {
      [ImageFormat.AVIF, ImageFormat.WEBP].forEach((format) => {
        alternatives.push({
          srcset: this.dprSrcset(format, i === 0 ? this.originalWidth : breakpoints[i - 1], i === 0 ? this.originalHeight : width * originalRatio * heights2[i]),
          mediaQuery: `(${i < breakpoints.length - 1 ? "min" : "max"}-width: ${width}px)`,
          type: `image/${format}`
        });
      });
    });
    return alternatives;
  }
  dprSrcset(format, width, height) {
    return [1, 2].map((i) => this.getPath({
      format,
      minWidth: width,
      minHeight: height,
      retina: i === 2,
      fit: this.customImgFit
    }) + " " + i + "x").join(", ");
  }
  getPath(params) {
    return cdnService.getImageUrl(getImagePath(this.imageType, this.path), params);
  }
};
__decorateClass([
  Prop(String)
], BackgroundComponent.prototype, "path", 2);
__decorateClass([
  Prop({ type: String, default: ImageType.PAGE_BACKGROUND })
], BackgroundComponent.prototype, "imageType", 2);
__decorateClass([
  Prop({ type: String, default: "" })
], BackgroundComponent.prototype, "alt", 2);
__decorateClass([
  Prop({ type: String })
], BackgroundComponent.prototype, "heights", 2);
__decorateClass([
  Prop({ type: String })
], BackgroundComponent.prototype, "breakpoints", 2);
__decorateClass([
  Prop({
    type: String,
    validator: (value) => validImageFit.includes(value)
  })
], BackgroundComponent.prototype, "imgFit", 2);
BackgroundComponent = __decorateClass([
  Component({
    name: "ui-background"
  })
], BackgroundComponent);

export default BackgroundComponent;
